import { render, staticRenderFns } from "./device-list.vue?vue&type=template&id=0c0b0f00&scoped=true&"
import script from "./device-list.vue?vue&type=script&lang=ts&"
export * from "./device-list.vue?vue&type=script&lang=ts&"
import style0 from "./device-list.vue?vue&type=style&index=0&id=0c0b0f00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0b0f00",
  null
  
)

export default component.exports